import { render, staticRenderFns } from "./SensorSettingItem.vue?vue&type=template&id=589216f8&scoped=true&"
import script from "./SensorSettingItem.vue?vue&type=script&lang=js&"
export * from "./SensorSettingItem.vue?vue&type=script&lang=js&"
import style0 from "./SensorSettingItem.vue?vue&type=style&index=0&id=589216f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589216f8",
  null
  
)

component.options.__file = "SensorSettingItem.vue"
export default component.exports